import { localStore, getParams } from '@dt/fe-utils'
import { languageDetector } from '@utils'
import defaultSmallImg from '@img/default-smallProduct.png'
import defaultStore from '@img/default_store.png'
import avatarImg from '@img/default-avatar.png'
import logoImg from '@img/default-logo.png'

// 当前timezone 默认为
const localTimezone = localStorage.getItem('store.timeZone')
const timezone = localTimezone || window.boJudge?.checkKey('timezoneDe') || window.boJudge?.checkKey('timezoneCn') || window.boJudge?.checkKey('timezoneUs') || 'America/Los_Angeles'
// 初始化参数
let { b = 0, s = 0, t = 0, p = 0, ct, et, ot = '', bt = '', city = '', appId = '', openId = '', language: lang, gopenId = '', token = '', lat = 0, lng = 0, memberId = 0, sync = 0, shareInfo = '', posLoginInfo = '', source = '', posResetInfo = '', tt = '', btRoomInit, inMiniApp, miniVersion, queueId } = getParams()
b = Number(b)
s = Number(s)
t = Number(t)
p = Number(p)
sync = Number(sync)
lat = Number(lat) || 0
lng = Number(lng) || 0
ct = ct || (b && s && t ? 'table' : b && s && !p ? 'store' : 'brand')
et = ct === 'brand' && et === 'togo' ? 'pickup' : et
if (token && location.pathname.includes('paypalreturn')) {
  token = ''
}
if (shareInfo) {
  localStorage.setItem(`ls.shareInfo.${b}`, shareInfo)
}
// 浏览器语言
const language = lang || localStore.get(`i18nextLng.${b}`) || languageDetector?.detectors?.navigatorPre?.lookup() || 'en-US'

/** 全局p配置 */
const Config: IConfig = {
  APP: 'handtop',
  RESTAURANTAPP: 'mobile',
  BRANDID: b, // 600213, 800201
  // 品牌码进入时STOREID会根据选择的门店修改；
  STOREID: s, // 800234
  /** 此处只设置进入链接传入的桌码，不可切换门店用餐模式 */
  TABLECODE: t,
  codeType: ct,
  eatType: et,
  /** 推广ID */
  promotionId: p,
  /** 拼单ID */
  buyTogetherId: bt,
  btRoomInit: !!btRoomInit,
  /** 是否是预下单 */
  isPreOrder: ot === 'preOrder' || tt === 'preOrder', // tt,ot => otherType
  otherType: ot,
  /** 排队ID */
  queueId: Number(queueId || localStore.get(`ls.queueId.${b}.${s}`)) || 0,
  /** 进入时的第一个state */
  firstState: '',
  // bo: 'us',
  i18n: language,
  timezone,
  cityName: city,
  /** 缓存3分钟 */
  payTypesMap: {
    heartland: 'bankCardOnline',
    cardconnect: 'bankCardOnline',
    stripe: 'bankCardOnline',
    paypal: 'bankCardOnline',
    citcon: 'credit',
    alipay: 'alipayFuWu',
    wxweb: 'wxWeb'
  },
  doPaymap: {
    citcon: 'credit',
    alipay: 'alipayWeb',
    wxweb: 'wxWeb'
  },
  targetType: tt,
  inMiniApp: !!inMiniApp,
  miniVersion: !!inMiniApp && miniVersion ? Number(miniVersion) : undefined,
  // googleMapKey: `AIzaSyCFL37RegJMrAg0WoYsvzb09Mz47H7UGpc&libraries=places&language=${mapLanguage}`,
  googleMapKey: 'AIzaSyCFL37RegJMrAg0WoYsvzb09Mz47H7UGpc&libraries=places',
  baiduMapKey: '84oWCrEPVUDk1Ge6RaGzRzb57wki7MwY',
  mktKeysMap: {},
  eatTypeMap: {
    dinein: i18n.t('menu.dinein'),
    togo: i18n.t('menu.togo'),
    delivery: i18n.t('menu.delivery')
  },
  defaultImg: {
    logo: logoImg, // 默认品牌图
    avatar: avatarImg, // 默认头像
    smallProduct: defaultSmallImg, // 餐品的小默认图片
    // darkBigProduct: defaultDarkBigImg, // 黑色背景下 餐品的大默认图片
    // darkSmallProduct: defaultDarkSmallImg, // 黑色背景下 餐品的小默认图片
    store: defaultStore, // 门店默认图片
    // product: defaultProduct
  },
  // 图片裁剪尺寸
  ImgSizeMap: {
    small: 128,
    middle: 640,
    big: 1280
  },
  /** 测试的LBS信息：定位为壹向大楼 */
  LBS: {
    latitude: lat,
    longitude: lng,
  },
  appId,
  openId,
  gopenId,
  token: token || localStore.get(`ls.token${window.appEnv}.` + b),
  setToken: (token: string) => {
    Config.token = token
    localStorage.setItem(`ls.token${window.appEnv}.` + Config.BRANDID, token)
    // TODO 处理过期的case 当前一年过期
  },
  clearToken: () => {
    Config.token = ''
    localStorage.removeItem(`ls.token${window.appEnv}.` + Config.BRANDID)
  },
  memberId,
  shareInfo: localStore.get(`ls.shareInfo.${b}`) || '',
  posLoginInfo,
  colorImages: ['#FF4E50', '#FC913A', '#F9D423', '#EDE574'],
  isSupportSync: !!sync,
  source,
  posResetInfo,
}

window.Config = Config

export default Config
